import type { CityIncludesWithToken } from '@bond/bruce-api/api/location/city/response'
import type { BookingMethodsBookingCredit } from '@bond/bruce-api/common/bookingMethods'

export function getCreditsDiscount(
  credits: number,
  city:
    | CityIncludesWithToken<{
        params: {
          include_country: true
          include_booking_methods: true
        }
      }>
    | undefined,
) {
  return (
    city?.booking_methods.find((method) => method.type === 'BOOKING_CREDIT') as
      | BookingMethodsBookingCredit
      | undefined
  )?.booking_credit_info.discount_intervals.find(
    (discount) =>
      discount.from <= credits && (!discount.to || discount.to >= credits),
  )
}
